import { render } from "./AffiliateRulesModal.vue?vue&type=template&id=fface3e2&scoped=true"
import script from "./AffiliateRulesModal.vue?vue&type=script&lang=js"
export * from "./AffiliateRulesModal.vue?vue&type=script&lang=js"

import "./AffiliateRulesModal.vue?vue&type=style&index=0&id=fface3e2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fface3e2"]])

export default __exports__